import { NavigationExtras, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AppConstants } from '../../../constants/AppConstants';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private navigationStack: string[] = [];

  constructor(private router: Router) {
    //Empty Constructor
  }

  /**
   * Navigates to a route and adds it to the navigation stack without removing previous routes.
   * @param route The target route path.
   * @param extras Optional navigation parameters.
   */
  public navigateTo(route: string, extras?: NavigationExtras): void {
    if (route) {
      // Add the current route to the navigation stack
      this.navigationStack.push(route);

      // Navigate to the specified route
      this.router.navigate([route], extras);
    } else {
      // Navigate to the specified route
      this.router.navigate([], extras);
    }
  }

  public navigateBack(): void {
    // Pop the current route from the navigation stack
    this.navigationStack.pop();

    // Navigate back to the previous route
    const previousRoute = this.navigationStack.pop();
    if (previousRoute) {
      this.router.navigateByUrl(previousRoute);
    }
  }

  /**
   * Navigate to Login
   * With Logout
   */
  public logout() {
    // Clear User Data from Local Storage
    // localStorage.clear();
    localStorage.removeItem(AppConstants.LocalStorageKeys.AUTH_TOKEN)

    // Navigate to Login Screen
    setTimeout(() => {
      this.router.navigate(['/auth']);
    }, 10);
  }
}
